<mat-dialog-content>
  <form [formGroup]="registerForm">
    <h2>
      <strong>{{ 'Register User' | translate }}</strong>
    </h2>
    <div class="text-margin">
      <span
        ><strong>{{ 'Name' | translate }}:</strong></span
      >
      <input
        class="form-control"
        type="text"
        placeholder="{{ 'Full name' | translate }}"
        formControlName="name"
      />
      @if (textValid('name')) {
        <span class="form-text text-danger">{{
          'You must type only a name and a lastname' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Email' | translate }}:</strong></span
      >
      <input
        class="form-control"
        type="text"
        placeholder="{{ 'Email' | translate }}"
        formControlName="email"
      />
      @if (textValid('email')) {
        <span class="form-text text-danger">{{
          'You must type a valid email' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Document Type' | translate }}:</strong></span
      >
      <select class="form-control" formControlName="types_docs">
        <option selected value="">{{ 'Select Type' | translate }}</option>
        @for (types of documenTypeList; track types) {
          <option [ngValue]="types">
            {{ types.description }}
          </option>
        }
      </select>
      @if (textValid('types_docs')) {
        <span class="form-text text-danger">{{
          'You must select a type' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Document' | translate }}:</strong></span
      >
      <input
        maxlength="12"
        class="form-control"
        type="text"
        placeholder="{{ 'Document' | translate }}"
        formControlName="document"
      />
      @if (textValid('document')) {
        <span class="form-text text-danger">{{
          'You must type only numbers' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Rol' | translate }}:</strong></span
      >
      <select class="form-control" formControlName="rol">
        <option selected value="">{{ 'Select rol' | translate }}</option>
        @for (rol of rolList; track rol) {
          <option [ngValue]="rol">
            {{ rol.name }}
          </option>
        }
      </select>
      @if (textValid('rol')) {
        <span class="form-text text-danger">{{
          'You must select a rol' | translate
        }}</span>
      }
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Company' | translate }}:</strong></span
      >
      <select
        (change)="onOptionSelected()"
        class="form-control"
        formControlName="company"
      >
        <option selected value="">{{ 'Select company' | translate }}</option>
        @for (company of companyList; track company) {
          <option [ngValue]="company">
            {{ company.name }}
          </option>
        }
      </select>
      @if (textValid('company')) {
        <span class="form-text text-danger">{{
          'You must select a company' | translate
        }}</span>
      }
    </div>
    @if (prefixList.length > 0) {
      <div class="text-margin">
        <span
          ><strong>{{ 'Prefix' | translate }}:</strong></span
        >
        <select class="form-control" formControlName="prefix">
          <option selected value="">{{ 'Select prefix' | translate }}</option>
          @for (prefix of prefixList; track prefix) {
            <option [ngValue]="prefix">
              {{ prefix.prefix }} - {{ 'Voucher' | translate }}:
              {{ prefix.voucher }}
            </option>
          }
        </select>
        @if (textValid('company')) {
          <span class="form-text text-danger">{{
            'You must select a prefix' | translate
          }}</span>
        }
      </div>
    }
    <div class="text-margin">
      <span
        ><strong>{{ 'Password' | translate }}:</strong></span
      >
      <input
        class="form-control"
        type="password"
        placeholder="{{ 'Password' | translate }}"
        formControlName="password"
      />
    </div>
    <div class="text-margin">
      <span
        ><strong>{{ 'Confirm Password' | translate }}:</strong></span
      >
      <input
        class="form-control"
        type="password"
        placeholder="{{ 'Confirm Password' | translate }}"
        formControlName="passwordConfirmation"
      />
      @if (textValid('passwordConfirmation')) {
        <span class="form-text text-danger">{{
          'Passwords must be equals' | translate
        }}</span>
      }
    </div>
    <div
      class="row"
      style="padding-left: 20px; margin-top: 10px"
      id="buttons-div"
    >
      <div class="col" id="buttons">
        <button (click)="register()" mat-raised-button>
          {{ 'Register' | translate }}
        </button>
      </div>
      <div class="col" id="buttons">
        <button mat-raised-button [mat-dialog-close]>
          {{ 'Cancel' | translate }}
        </button>
      </div>
    </div>
  </form>
</mat-dialog-content>
